import { InMemoryOriginsRepository } from "../../../../../test/repositories/inMemoryOriginsRepository"
import { makeOrigin } from "../../../../../test/factories/makeOrigin"
import { DeleteOriginByNameUseCase } from "./deleteOriginByName"
import { IDeleteOriginByNameProtocol } from "../../protocols/origin/IDeleteOriginByNameProtocol"

let sut: IDeleteOriginByNameProtocol
let repository: InMemoryOriginsRepository

describe('Delete Origin By Name', () => {
  beforeEach(() => {
    repository = new InMemoryOriginsRepository()
    sut = new DeleteOriginByNameUseCase(repository)
  })
  it('Should be able to delete a origin by name', async () => {
    const originOnDatabase = makeOrigin({
      name: 'Test Origin'
   })
   await repository.create(originOnDatabase)

   await sut.execute({
    originName: 'Test Origin'
   })

    expect(repository.items.length).toEqual(0)
  })
})